<template>
  <div>
    <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
          d="M13 23C14.2412 22.9966 15.2466 21.9883 15.25 20.7436H10.75C10.75 21.9898 11.7574 23 13 23ZM19.75 16.2308V10.5897C19.75 7.12661 17.905 4.22667 14.6875 3.45949V2.69231C14.6875 1.7577 13.9319 1 13 1C12.068 1 11.3125 1.7577 11.3125 2.69231V3.45949C8.0842 4.22667 6.25 7.11487 6.25 10.5897V16.2308L4 18.4872V19.6154H22V18.4872L19.75 16.2308Z"
          :fill="color"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'IconSvgSnmmiNotifications',
  props: {
    color: {
      type: String,
      default: '#000000',
    },
    size: {
      type: Number,
      default: null,
    },
  },
  computed: {
    iconSize() {
      return this.size ? `${this.size}px` : '44px'
    },
  },
}
</script>

<style scoped></style>